import { request } from './core';

export interface InvoiceSettings {
  business_name: string;
  business_address: string;
  business_city: string;
  business_country: string;
  kvk_number: string;
  btw_number: string;
  number_format: string;
}

export interface UserTheme {
  ID: string;
  UserID: string;
  Name: string;
  TemplateID: string;
  AccentColor: string;
  BackgroundColor: string;
  TextColor: string;
  DarkPrimary: string;
  DarkBackground: string;
  DarkText: string;
  FontFamily: string;
  CreatedAt: string;
}

export const accountApi = {
  getAccountUsage: () =>
    request<{
      bytes_used: number; bytes_limit: number;
      asset_count: number; gallery_count: number;
      retention_default_days: number | null;
      plan_name: string;
    }>("GET", "/api/v1/account/usage"),
  getRetentionDefault: () =>
    request<{ retention_default_days: number | null }>("GET", "/api/v1/account/retention-default"),
  setRetentionDefault: (days: number | null) =>
    request<{ retention_default_days: number | null }>("PUT", "/api/v1/account/retention-default", { retention_default_days: days }),
  recordUpgradeInterest: (tier: string, notes?: string) =>
    request<{ status: string }>("POST", "/api/v1/account/upgrade-interest", { tier, notes: notes ?? "" }),
  listThemes: () => request<UserTheme[]>("GET", "/api/v1/themes"),
  saveTheme: (t: Omit<UserTheme, "ID" | "UserID" | "CreatedAt">) => request<UserTheme>("POST", "/api/v1/themes", t),
  deleteTheme: (id: string) => request<void>("DELETE", `/api/v1/themes/${id}`),
  adminOverview: () => request<{ status: string }>("GET", "/api/v1/admin/overview"),
  aiGenerate: (kind: string, context: Record<string, string>) =>
    request<{ text: string }>("POST", "/api/v1/ai/generate", { kind, context }),
  getInvoiceSettings: () => request<InvoiceSettings>("GET", "/api/v1/account/invoice-settings"),
  updateInvoiceSettings: (s: Partial<InvoiceSettings>) =>
    request<InvoiceSettings>("PUT", "/api/v1/account/invoice-settings", s),
};
